module.exports = __webpack_public_path__ + "assets/img/paypal.10d0a456.svg";